import { render } from "./AjusteManual.vue?vue&type=template&id=b5b1eef0"
import script from "./AjusteManual.vue?vue&type=script&lang=js"
export * from "./AjusteManual.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__